import { useMemo } from 'react';
import {
  DEFAULT_KEY_METRICS_LIST,
  DEFAULT_STATUS_LIST,
  DEFAULT_GR_LIST,
  DEFAULT_LAUNCH_LIST,
} from '../constants';

import type { KeyMetricsListType, StatusListItemType } from '@/pages/globalpedia/types/overview';
import type { KeyMetricsCardListItemType } from '../types';

// 项目进度枚举值
/* export const PROGRESS_ENUM: {[keyName: number]: string} = {
  1: 'On Track',
  2: 'At Risk',
  3: 'Monitor',
  4: 'On Hold',
  5: 'Not Started',
}; */

const setStatusListItem = (
  currentList: KeyMetricsCardListItemType,
  currentIndex: number,
  item: StatusListItemType,
) => {
  const newListItem = DEFAULT_STATUS_LIST?.list?.[currentIndex];
  const list = item?.list;
  if (Array.isArray(item?.list)) {
    newListItem.value = String(list?.length);
    const newModalList = [];
    for (let j = 0, len = list?.length; j < len; j++) {
      const k = list?.[j];
      newModalList.push({
        title: k?.project,
        img: k?.cover,
        id: k?.project_id,
      });
    }
    newListItem.modalList = newModalList;
  }
  currentList.list[currentIndex] = newListItem;
};

export default function useKeyMetricsList(params: { loading: boolean; data: KeyMetricsListType }) {
  const { loading, data } = params;

  const keyMetricsList = useMemo(() => {
    if (loading) return DEFAULT_KEY_METRICS_LIST;
    const res = [];
    const statusList = data?.status_list;
    const projectNum = data?.project_total || 0;
    const grList = data?.gr_list;
    const launchList = data?.launch_list;

    // Number of Projects
    if (statusList && Array.isArray(statusList)) {
      const newList = { ...DEFAULT_STATUS_LIST };
      let num = 0;
      newList.list = [...DEFAULT_STATUS_LIST?.list];
      for (let i = 0, l = statusList?.length; i < l; i++) {
        const t = statusList?.[i];
        if (Array.isArray(t?.list)) {
          num += t?.list?.length;
        }
        if (t?.status === '2') {
          setStatusListItem(newList, 0, t);
          /* const newListItem = DEFAULT_STATUS_LIST?.list?.[0], list = t?.list;
          if (Array.isArray(t?.list)) {
            newListItem.value = String(list?.length);
            const newModalList = [];
            for(let j = 0, len = list?.length; j < len; j ++) {
              const k = list?.[j];
              newModalList.push({
                title: k?.project,
                img: k?.cover,
                id: k?.project_id,
              });
            }
            newListItem.modalList = newModalList;
          }
          newList.list[0] = newListItem; */
        }
        // Monitor
        if (t?.status === '3') {
          setStatusListItem(newList, 1, t);
        }
        // On Track
        if (t?.status === '1') {
          setStatusListItem(newList, 2, t);
        }
        // Others
        if (t?.status === 'others') {
          setStatusListItem(newList, 3, t);
        }
      }
      newList.num = projectNum;
      // newList.num = num;
      res.push(newList);
    } else {
      res.push(DEFAULT_STATUS_LIST);
    }

    // Official Review
    if (statusList && Array.isArray(grList)) {
      const newList = { ...DEFAULT_GR_LIST };
      newList.num = grList?.length || 0;
      if (newList.num > 1) {
        newList.title = newList.title.replace('Review', 'Reviews');
      }
      const list = [];
      for (let i = 0, l = grList?.length; i < l; i++) {
        const t = grList?.[i];
        list.push({
          title: t?.project,
          id: t?.project_id,
          img: t?.cover,
          time: t?.date,
          timeConfirm: t?.date_confirm,
        });
      }
      newList.list = list;
      res.push(newList);
    } else {
      res.push(DEFAULT_GR_LIST);
    }

    // Launch
    if (statusList && Array.isArray(launchList)) {
      const newList = { ...DEFAULT_LAUNCH_LIST };
      newList.num = launchList?.length || 0;
      const list = [];
      for (let i = 0, l = launchList?.length; i < l; i++) {
        const t = launchList?.[i];
        list.push({
          title: t?.project,
          id: t?.project_id,
          img: t?.cover,
          time: t?.date,
          timeConfirm: t?.date_confirm,
        });
      }
      newList.list = list;
      res.push(newList);
    } else {
      res.push(DEFAULT_LAUNCH_LIST);
    }
    return res;
  }, [loading]);

  return keyMetricsList;
}
